const mockPurchaseHistoryData = [
    {
        "id": 78,
        "amount": 3,
        "credits_balance": 33,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2023-11-21T07:17:56.211917Z"
    },
    {
        "id": 77,
        "amount": 1,
        "credits_balance": 30,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2023-11-21T07:17:52.831448Z"
    },
    {
        "id": 63,
        "amount": 4,
        "credits_balance": 68,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2022-06-22T17:12:16.859610Z"
    },
    {
        "id": 62,
        "amount": 4,
        "credits_balance": 64,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2022-06-22T17:09:14.920220Z"
    },
    {
        "id": 61,
        "amount": 5,
        "credits_balance": 60,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2022-06-22T17:06:51.725560Z"
    },
    {
        "id": 54,
        "amount": 1,
        "credits_balance": 49,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2022-06-19T12:03:50.835398Z"
    },
    {
        "id": 53,
        "amount": 10,
        "credits_balance": 48,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2022-06-19T12:00:07.186233Z"
    },
    {
        "id": 52,
        "amount": 4,
        "credits_balance": 38,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2022-06-19T11:49:25.323942Z"
    },
    {
        "id": 51,
        "amount": 5,
        "credits_balance": 70,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2022-06-19T11:47:22.740726Z"
    },
    {
        "id": 49,
        "amount": 5,
        "credits_balance": 65,
        "is_success": true,
        "notes_reason": "succeeded",
        "stripe_receipt_url": "",
        "created": "2022-06-19T09:41:14.352758Z"
    }
]
export default mockPurchaseHistoryData;